import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
})
export class CustomersComponent implements OnInit {

    static componentName = 'CustomersComponent';
    post: any;
    customerList: any;

    constructor(
        private dataService: DataService,
    ) {}

    getPost(): void {
        this.dataService.getPost('kunder')
            .subscribe(res => this.post = res);
    }

    getCustomerList(): any {
        this.dataService.getField('kunder', null, 'customers')
            .subscribe(res => this.convertCustomerList(res['customers']));
    }

    convertCustomerList(res): any {
        this.customerList = Object.keys(res).map(function(resNamedIndex) {
            return res[resNamedIndex].customer;
        });
    }

    ngOnInit() {
        this.getPost();
        this.getCustomerList();

        setTimeout(() => {
            if (document.querySelectorAll('.customers-hero').length) {
                document.querySelectorAll('.customers-hero')[0].classList.add('show');
            }
        }, 1300);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/customers/customers.component.ts